import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";


function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);

    // 👉 FIX: Run once on refresh also!
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

const sectionOffsets = {
  home: 150,
  services: 90,
  about: 30,
  contact: 120,
};


const goToSection = (id) => {
  const offset = sectionOffsets[id] || 90; // default 90

  if (location.pathname !== "/") {
    navigate("/", { state: { scrollTo: id } });
  } else {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        const y =
          element.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
    }, 200);
  }
};


  return (
    <div
      className={`bg-white flex flex-col sm:flex-row justify-between items-center 
  px-4 sm:px-6 md:px-8 py-5 shadow-md sticky top-0 z-50 
  ${scrolled ? "shadow-lg" : ""}`}
    >

      <h1
        onClick={() => goToSection("home")}
        className="flex items-center gap-1 text-xl sm:text-2xl lg:text-2xl font-bold 
             mb-2 sm:mb-3 md:mb-0 cursor-pointer transition-colors duration-200 
             touch-manipulation"
      >
       <img
  src="/orisonlogo.svg"
  alt="Logo"
  className="w-28 h-18 sm:w-40 sm:h-10 lg:w-22 lg:h-22"
/>


        {/* GROUP TEXT */}
      
      </h1>





      <ul className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 lg:gap-8 text-sm sm:text-base text-gray-800 font-medium">
        <li>
          <button
            onClick={() => goToSection("home")}
            className="hover:text-blue-600 active:text-blue-700 transition-colors duration-200 relative group py-1 px-2"
          >
            Home
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
          </button>
        </li>

        <li>
          <button
            onClick={() => goToSection("services")}
            className="hover:text-blue-600 active:text-blue-700 transition-colors duration-200 relative group py-1 px-2"
          >
            Services
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
          </button>
        </li>

        <li>
          <button
            onClick={() => goToSection("about")}
            className="hover:text-blue-600 active:text-blue-700 transition-colors duration-200 relative group py-1 px-2"
          >
            About us
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
          </button>
        </li>

        <li>
          <button
            onClick={() => goToSection("contact")}
            className="hover:text-blue-600 active:text-blue-700 transition-colors duration-200 relative group py-1 px-2"
          >
            Contact us
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
          </button>
        </li>
      </ul>
    </div>
  );
}

export default Navbar;
